module.exports = __webpack_public_path__ + "img/11.cb11799a.webp";